import { render, staticRenderFns } from "./ReceiverSettingsForm.vue?vue&type=template&id=5d0ac7de&"
import script from "./ReceiverSettingsForm.vue?vue&type=script&lang=js&"
export * from "./ReceiverSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports